<template>
    <fw-table  :apiService="sysDictServiceApi" :grid-config="configData.gridConfig" :grid-btn-config="configData.gridBtnConfig"
              :form-config="configData.formConfig" :form-data="configData.formModel" :grid-edit-width="200"
              form-title="字典表信息" :is-async="true" :query-config="configData.queryConfig" :query-model="configData.queryModel"
              :dialog-config="configData.dialogConfig" :grid-top-btn-config="configData.gridTopBtnConfig">
    </fw-table>
</template>

<script>
  import {DATA_CONFIG} from './config/config.js'
  import {sysDictService} from '../../../api/generator/generator/sysDict.js'

  export default {
    components: {
    },
    data () {
      return {
        testData: [],
        configData: DATA_CONFIG,
        sysDictServiceApi: sysDictService
      }
    },
    name: 'sysDict-list',
    mounted () {
    },
    methods: {
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/generator/sysDict/index.vue